import { IContentControlledItemSettings } from './i-content-controlled-item-settings';
import { ContentControlledSettingsAIDetections } from './content-controlled-settings-ai-detections';
export class ContentControlledVODSettings
  implements IContentControlledItemSettings
{
  public readonly discriminator = 'VOD';
  constructor(public aiDetections: ContentControlledSettingsAIDetections) {}

  clone(): IContentControlledItemSettings {
    return new ContentControlledVODSettings(this.aiDetections);
  }
  static empty() {
    return new ContentControlledVODSettings({ scalingFactor: 1 });
  }
}
